import Component from '../../components/Component';
import ListData from '../../components/ListData';

import { ConceptsSkeys, celebrityKeys } from './keys';
import query from './query';

class Summary extends Component {
    constructor(props) {
        super();
        this.query = query(props.page);
    }

    render() {
        const dataForEntities = this.state.data?.filter((item) => item.wiki);
        const dataForConcepts = this.state.data?.filter((item) => !item.wiki);
        return (
            <div className="row">
                <div className="col-6 col-xs-12" id="top-celebrities">
                    <ListData
                        loading={this.state.loading}
                        header={this.props.header ?? 'Entities'}
                        subheader={this.props.subheader ?? '(by relevancy)'}
                        forceRun={this.forceRun}
                        link={`/domain/${this.props.domain_id}/categories`}
                        keys={celebrityKeys}
                        uniqKey="level"
                        data={dataForEntities}
                        itemClassName={this.props.page ? 'justify-content-start' : ''}
                        cardClassName={'list-data-full'}
                        customEmptyMessage={this.props.error_message}
                    />
                </div>
                <div className="col-6 col-xs-12" id="top-entities">
                    <ListData
                        loading={this.state.loading}
                        data={dataForConcepts}
                        label={this.props.label || 'CONCEPTS'}
                        keys={ConceptsSkeys}
                        forceRun={this.forceRun}
                        header={this.props.header ?? 'Recommended Concepts'}
                        subheader={this.props.subheader ?? '(Non-Wikipedia Entities)'}
                        itemClassName={this.props.page ? 'justify-content-start' : ''}
                        cardClassName={'list-data-full'}
                        customEmptyMessage={this.props.error_message}
                    />
                </div>
            </div>
        );
    }
}

export default Summary;
